<h1 i18n>Conversion Errors</h1>
<mat-form-field class="full-width">
  <input matInput placeholder="Filter by Filename" [ngModel]="fileNameFilter()" (ngModelChange)="onFileNameFilter($event)" />
</mat-form-field>


<da-multi-select-client
  class="full-width"
  label="Filter by Client"
  placeholder="Pick client..."
  [list]="clients()"
  (selectingChange)="filterClients($event)"
  >
</da-multi-select-client>

<da-multi-select-client
  class="full-width"
  label="Excluded Clients"
  placeholder="Pick client..."
  [list]="clients()"
  (selectingChange)="excludedClients($event)"
  >
</da-multi-select-client>

<mat-table [dataSource]="dataSource" matSort (matSortChange)="onSort($event)">
  <ng-container matColumnDef="dateUtc">
    <mat-header-cell mat-sort-header *matHeaderCellDef i18n> Run at </mat-header-cell>
    <mat-cell *matCellDef="let row"> {{ row.dateUtc | date : 'dd.MM.yyyy HH:mm' }} </mat-cell>
  </ng-container>
  <ng-container matColumnDef="fileName">
    <mat-header-cell mat-sort-header *matHeaderCellDef i18n> Filename </mat-header-cell>
    <mat-cell *matCellDef="let row"> {{ row.fileName }} </mat-cell>
  </ng-container>
  <ng-container matColumnDef="clientName">
    <mat-header-cell mat-sort-header *matHeaderCellDef i18n> Client </mat-header-cell>
    <mat-cell *matCellDef="let row"> {{ row.clientName }} </mat-cell>
  </ng-container>
  <mat-header-row *matHeaderRowDef="['dateUtc', 'fileName', 'clientName']"></mat-header-row>
  <mat-row (click)="showDetail(row)" *matRowDef="let row; columns: ['dateUtc', 'fileName', 'clientName']"></mat-row>
</mat-table>
@if (conversionErrorsPaginated()) {
  <mat-paginator
    [length]="conversionErrorsPaginated().totalCount"
    [pageSize]="conversionErrorsService.pageSize"
    [pageIndex]="conversionErrorsService.page - 1"
    [pageSizeOptions]="[5, 10, 25, 100]"
    (page)="onPage($event)"
    >
  </mat-paginator>
}
